import {
  select,
  put,
  fork,
  call,
  take,
  takeEvery,
  all,
} from 'redux-saga/effects';
import app from '../../app';
import {
  loadRefundOrderListCompletion,
  loadRefundCompletion,
  loadRefundRecordListCompletion,
  createRefundExpressCompletion,
  cancelApplyRefundCompletion,
  loadInfoForRefundRecordCreateCompletion,
  createRefundRecordCompletion,
  catchError,
  createRefundMoneyCompletion,
  loadRefundMoneyCompletion,
} from '../../actions';

export function* watchLoadRefundOrderList() {
  yield takeEvery('LOAD_REFUND_ORDER_LIST', function*({ range, keyword }) {
    const options = {
      url: `/api/after/canApply/list?start=${range.location}&size=${range.length}&keyword=${keyword}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadRefundOrderListCompletion(range, keyword, result.data, result.error)
    );
  });
}

export function* watchLoadRefund() {
  yield takeEvery('LOAD_REFUND', function*({ recordId }) {
    const options = {
      url: `/api/after/${recordId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadRefundCompletion(recordId, result.data, result.error));
  });
}

export function* watchLoadRefundRecordList() {
  yield takeEvery('LOAD_REFUND_RECORD_LIST', function*({ range, keyword }) {
    const options = {
      url: `/api/after/list?start=${range.location}&size=${range.length}&keyword=${keyword}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadRefundRecordListCompletion(range, keyword, result.data, result.error)
    );
  });
}

export function* watchCreateRefundExpress() {
  yield takeEvery('CREATE_REFUND_EXPRESS', function*({ recordId }) {
    const expressCreate = yield select(
      state => state.service.refund.expressCreate
    );
    const {
      input: { receiveCompany, receiveExpressNo },
      addressId,
    } = expressCreate;
    let error;

    if (!receiveExpressNo) {
      error = new Error('请输入快递单号');
    } else if (!receiveCompany) {
      error = new Error('请选择快递公司');
    } else if (!addressId) {
      error = new Error('请选择回寄地址');
    }

    if (error) {
      yield put(catchError(error));
      yield put(createRefundExpressCompletion(recordId, error));
      return;
    }

    const options = {
      url: '/api/after/upload/express',
      method: 'POST',
      data: {
        afterSaleId: recordId,
        receiveCompany,
        receiveExpressNo,
        addressId,
      },
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      createRefundExpressCompletion(recordId, result.error, result.data)
    );

    if (!result.error) {
      app.showTips('succ', '快递信息提交成功');
    }
  });
}

export function* watchCancelApplyRefund() {
  while (true) {
    const { afterSaleId } = yield take('CANCEL_APPLY_REFUND');
    const options = {
      url: `/api/after/${afterSaleId}/cancel`,
      method: 'POST',
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      cancelApplyRefundCompletion(afterSaleId, result.data, result.error)
    );
  }
}

export function* watchCreateRefundRecord() {
  yield takeEvery('CREATE_REFUND_RECORD', function*({ orderSkuId }) {
    const [input, recordInfo] = yield select(state => [
      state.service.refund.recordCreate.input,
      state.service.refund.recordCreate.info,
    ]);

    let error, refundType;
    const { type, num, note, img, name, mobile } = input;

    if (recordInfo && recordInfo.orderSku) {
      if (recordInfo.orderSku.afterSale === 3) {
        refundType = 3;
      } else {
        refundType = type;
      }
    }

    if (!note) {
      error = new Error('请输入问题描述');
    } else if (!name) {
      error = new Error('请输入联系人');
    } else if (!mobile) {
      error = new Error('请输入手机号码');
    }

    if (error) {
      yield put(catchError(error));
      yield put(createRefundRecordCompletion(orderSkuId, error));
      return;
    }

    const options = {
      url: '/api/after/apply',
      method: 'POST',
      data: { orderSkuId, type: refundType, num, note, img, name, mobile },
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      createRefundRecordCompletion(orderSkuId, result.error, result.data)
    );

    if (!result.error) {
      app.showTips('succ', '申请提交成功');
    }
  });
}

export function* watchLoadInfoForRefundRecordCreate() {
  yield takeEvery('LOAD_INFO_FOR_REFUND_RECORD_CREATE', function*({
    orderSkuId,
  }) {
    const options = {
      url: `/api/after/sku/${orderSkuId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadInfoForRefundRecordCreateCompletion(
        orderSkuId,
        result.error,
        result.data
      )
    );
  });
}

export function* watchCreateRefundMoney() {
  yield takeEvery('CREATE_REFUND_MONEY', function*({ orderId }) {
    const moneyCreate = yield select(state => state.service.refund.moneyCreate);
    const {
      input: { refundMoneyReason },
    } = moneyCreate;
    let error;

    if (!refundMoneyReason) {
      error = new Error('请选择退款原因');
    }

    if (error) {
      yield put(catchError(error));
      yield put(createRefundMoneyCompletion(orderId, error));
      return;
    }

    const options = {
      url: `/api/after/${orderId}/refund`,
      method: 'POST',
      data: { reason: refundMoneyReason },
    };
    const result = yield call(app.httpFetch, options);
    yield put(createRefundMoneyCompletion(orderId, result.error, result.data));

    if (!result.error) {
      app.showTips('succ', '申请退款信息提交成功');
    }
  });
}

export function* watchLoadRefundMoney() {
  yield takeEvery('LOAD_REFUND_MONEY', function*({ orderId }) {
    const options = {
      url: `/api/after/${orderId}/refund/detail`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadRefundMoneyCompletion(orderId, result.error, result.data));
  });
}

export default function* replaceSaga() {
  yield all([
    fork(watchLoadRefundOrderList),
    fork(watchLoadRefund),
    fork(watchLoadRefundRecordList),
    fork(watchCreateRefundExpress),
    fork(watchCancelApplyRefund),
    fork(watchCreateRefundRecord),
    fork(watchLoadInfoForRefundRecordCreate),
    fork(watchCreateRefundMoney),
    fork(watchLoadRefundMoney),
  ]);
}
